import {
  ActionLabel,
  getPlaceholder,
  getPlaceholderForConversionReportType,
  getStatus,
  getStatusForConversionReportType,
  isFromScratch,
  isMinimalFiling,
  statusKeys
} from '../../../data';
import { useNavigate } from 'react-router-dom';
import { useCopyAIFs } from '../../../../../../services/automation.service';
import { ClipLoader } from 'react-spinners';
import { FaArrowRight } from 'react-icons/fa6';

import toast from 'react-hot-toast';
import { REPORT_NAMINGS, REPORT_TYPES } from '../../../../../../consts/reportTypes';

export const AIFColumn = ({
  period,
  /* Only the redesign needs it: its AIFs page has an address of its own, where the classic one is
     a child of the periods route and is reached by a relative path. */
  workflowId,
  isLatestPeriod,
  setSelectedPeriodId,
  setIsOpenReadonlyAIFDrawer,
  setIsOpenUpdateAIFsModal,
  refetch,
  reportType
}) => {
  const navigate = useNavigate();

  const copyAIFs = useCopyAIFs();
  const status =
    reportType === REPORT_TYPES.CONVERSION
      ? getStatusForConversionReportType(period)
      : getStatus(period, reportType);

  const placeholder =
    reportType === REPORT_TYPES.CONVERSION
      ? getPlaceholderForConversionReportType(period)
      : getPlaceholder(period, reportType);

  const handleCopy = () => {
    if (isFromScratch(period) && reportType === REPORT_TYPES.CONVERSION) {
      return navigate(`${period.id}/add-aifs`);
    } else if (isFromScratch(period)) {
      return navigate(`${period.id}/add-aifs`);
    }

    copyAIFs.mutate(
      { period_id: period.id },
      {
        onSuccess: () => {
          refetch();
          setSelectedPeriodId(period.id);
          setIsOpenUpdateAIFsModal(true);
          toast.success(
            `${REPORT_NAMINGS.FUND?.[reportType]}s from previous period have been copied`,
            {
              position: 'bottom-center'
            }
          );
        }
      }
    );
  };

  const handleNavigateAddFundsPage = e => {
    e.preventDefault();
    e.stopPropagation();

    if (status === statusKeys.JURISDICTION || status === statusKeys.AIF)
      return navigate(`${period.id}/add-aifs`);

    setSelectedPeriodId(period.id);
    setIsOpenReadonlyAIFDrawer(true);
  };

  if (isMinimalFiling(period)) {
    return <span style={{ color: '#adb5bd', fontSize: 14 }}>N/A</span>;
  }

  if (copyAIFs.isLoading)
    return (
      <ActionLabel
        style={{ width: 120 }}
        label="In progress"
        rightIcon={<ClipLoader size={16} color="#228BE6" />}
      />
    );

  if (reportType === REPORT_TYPES.CONVERSION && status !== statusKeys.AIF && !period.fund_count) {
    return <ActionLabel style={{ width: 120 }} placeholder={placeholder} />;
  }

  if (status === statusKeys.AIF && !period.fund_count)
    return (
      <ActionLabel
        style={{ width: 120 }}
        label={`Add ${REPORT_NAMINGS.FUND?.[reportType]}s`}
        onClick={handleCopy}
      />
    );

  return (
    <ActionLabel
      style={{ width: 120 }}
      label={`${period.fund_count} ${REPORT_NAMINGS.FUND?.[reportType]}s`}
      onClick={handleNavigateAddFundsPage}
      data-test-id="navigate-aif"
      rightIcon={<FaArrowRight />}
    />
  );
};
